import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Notification Banner store with localStorage persistence
 * Manages persistent notification banner state that shows after payment success
 * Banner displays for 5 minutes from the notification creation time
 */
export const useNotificationBannerStore = create(
  persist(
    (set) => ({
      // Notification banner state
      hasBeenDismissed: false,
      shouldShowNotification: false,
      setHasBeenDismissed: (state) => set({ hasBeenDismissed: state }),
      setShouldShowNotification: (state) => set({ shouldShowNotification: state }),
      // Dismiss the notification banner
      dismissNotification: () => {
        set({ shouldShowNotification: false });
      },
      resetNotificationBannerStore: () => {
        set({ hasBeenDismissed: false, shouldShowNotification: false });
      },
    }),
    {
      partialize: (state) => ({
        shouldShowNotification: state.shouldShowNotification,
        hasBeenDismissed: state.hasBeenDismissed,
      }),
      name: 'notification-banner-storage', // localStorage key
      version: 1,
    }
  )
);

export default useNotificationBannerStore;
